<template>
    <ElencoCommesse />
</template>

<script>
import ElencoCommesse from "@/components/commesse/ElencoCommesse.vue";

export default {
    name: "HomePage",
    components: {
        ElencoCommesse,
    },
};
</script>
